import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <div className="privacy-container">
        <div className="privacy-header">
          <Link to="/" className="back-link">← Back to Home</Link>
          <h1 className="privacy-title">Privacy Policy</h1>
          <p className="privacy-last-updated">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
        </div>

        <div className="privacy-content">
          <p className="privacy-intro">
            This Privacy Policy explains how LearnFi (Pvt) Ltd (PV 00325492) ("LearnFi Business", "LearnFi", "we", "us", "our") collects, uses, and protects your personal information when you use any of our websites, platforms, or services (the "Site"). By accessing or using our Site, you consent to the practices described in this Policy.
          </p>

          <p className="privacy-intro">
            LearnFi is committed to protecting your privacy and handling your information responsibly in accordance with the laws of Sri Lanka.
          </p>

          <section className="privacy-section">
            <h2 className="privacy-section-title">A. INFORMATION WE COLLECT</h2>
            <p className="privacy-text">
              We collect personal information to provide and improve our services. "Personal information" means any data that identifies you directly or indirectly.
            </p>
            <p className="privacy-text">
              We may collect information in the following ways:
            </p>

            <h3 className="privacy-subsection-title">1. Information you provide voluntarily</h3>
            <ul className="privacy-list">
              <li>Name, email address, phone number</li>
              <li>Billing, payment information</li>
              <li>Account login details</li>
              <li>Information submitted through forms, support requests, or course enrollments</li>
              <li>Job applications (CVs, employment history, qualifications)</li>
            </ul>

            <h3 className="privacy-subsection-title">2. Information collected automatically</h3>
            <p className="privacy-text">
              Through cookies, analytics tools, and your device:
            </p>
            <ul className="privacy-list">
              <li>IP address</li>
              <li>Browser type and version</li>
              <li>Device information</li>
              <li>Pages visited, time spent, navigation patterns</li>
              <li>Referring URLs</li>
              <li>General location data</li>
            </ul>

            <h3 className="privacy-subsection-title">3. Information from cookies & tracking tools</h3>
            <p className="privacy-text">
              We use cookies and similar technologies to:
            </p>
            <ul className="privacy-list">
              <li>Improve website performance</li>
              <li>Analyze usage patterns</li>
              <li>Personalize user experience</li>
              <li>Deliver marketing and retargeting</li>
            </ul>
            <p className="privacy-text">
              Tools used may include: Google Analytics, Facebook Pixel, LinkedIn Insight Tag, and other analytics services.
            </p>
            <p className="privacy-text">
              You may disable cookies through your browser, but some website functions may not work properly.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">B. HOW WE USE YOUR INFORMATION</h2>
            <p className="privacy-text">
              LearnFi may use your personal information for:
            </p>
            <ul className="privacy-list">
              <li>Delivering and improving our courses, services, and content</li>
              <li>Processing payments and managing your account</li>
              <li>Communicating updates, support, and promotional materials</li>
              <li>Analyzing user behaviour and improving user experience</li>
              <li>Processing employment applications</li>
              <li>Ensuring system security, fraud prevention, and compliance with the law</li>
              <li>Creating aggregated, anonymized analytics for internal use</li>
            </ul>
            <p className="privacy-text">
              We do not sell your personal information to third parties.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">C. DISCLOSURE OF INFORMATION</h2>
            <p className="privacy-text">
              We may share your information with:
            </p>

            <h3 className="privacy-subsection-title">1. Service providers</h3>
            <p className="privacy-text">
              Trusted third parties such as:
            </p>
            <ul className="privacy-list">
              <li>Payment processors</li>
              <li>Cloud hosting providers</li>
              <li>Email service providers</li>
              <li>Analytics and marketing partners</li>
            </ul>
            <p className="privacy-text">
              All such parties operate under confidentiality obligations.
            </p>

            <h3 className="privacy-subsection-title">2. Legal requirements</h3>
            <p className="privacy-text">
              We may disclose information if required by:
            </p>
            <ul className="privacy-list">
              <li>Law enforcement</li>
              <li>Court orders</li>
              <li>Regulatory authorities</li>
            </ul>

            <h3 className="privacy-subsection-title">3. Business operations</h3>
            <p className="privacy-text">
              In case of:
            </p>
            <ul className="privacy-list">
              <li>Mergers</li>
              <li>Acquisitions</li>
              <li>Corporate restructuring</li>
            </ul>
            <p className="privacy-text">
              your information may be transferred with appropriate safeguards.
            </p>

            <h3 className="privacy-subsection-title">4. Public interactions</h3>
            <p className="privacy-text">
              If you post reviews, comments, forums, or feedback on our platform, such content may become publicly visible.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">D. DATA RETENTION</h2>
            <p className="privacy-text">
              We retain personal information only as long as necessary for:
            </p>
            <ul className="privacy-list">
              <li>Service delivery</li>
              <li>Legal compliance</li>
              <li>Security, audit, or accounting requirements</li>
            </ul>
            <p className="privacy-text">
              Information may be stored longer in anonymized form for research or statistical purposes.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">E. CHILDREN'S PRIVACY</h2>
            <p className="privacy-text">
              Our site and services are not intended for individuals under 18 years of age. We do not knowingly collect information from children.
            </p>
            <p className="privacy-text">
              If you believe a minor has submitted personal data, please contact us immediately for removal.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">F. YOUR RIGHTS</h2>
            <p className="privacy-text">
              Subject to applicable laws, you may request:
            </p>
            <ul className="privacy-list">
              <li>Access to your personal information</li>
              <li>Correction of inaccurate details</li>
              <li>Deletion of your data</li>
              <li>Withdrawal of consent (where processing is based on consent)</li>
              <li>Transfer of your data to another provider (where applicable)</li>
            </ul>
            <p className="privacy-text">
              We may require verification before responding to such requests.
            </p>
            <p className="privacy-text">
              Some data may not be deleted if retained for legal or security purposes.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">G. SECURITY</h2>
            <p className="privacy-text">
              We use reasonable technical and organizational measures to protect personal information from:
            </p>
            <ul className="privacy-list">
              <li>Unauthorized access</li>
              <li>Loss</li>
              <li>Misuse</li>
              <li>Alteration</li>
            </ul>
            <p className="privacy-text">
              However, no internet transmission is 100% secure; therefore, we cannot guarantee absolute security.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">H. CHANGES TO THIS POLICY</h2>
            <p className="privacy-text">
              LearnFi may update this Privacy Policy from time to time. Changes will be posted on this page with an updated "Last Updated" date.
            </p>
            <p className="privacy-text">
              Your continued use of the Site after changes indicates acceptance of the updated Policy.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">I. CONTACT US</h2>
            <p className="privacy-text">
              For questions, requests, or complaints regarding this Privacy Policy, please contact:
            </p>
            <div className="privacy-contact-info">
              <p className="privacy-text"><strong>LEARNFI (PVT) LTD</strong></p>
              <p className="privacy-text">Colombo, Sri Lanka</p>
              <p className="privacy-text">Email: support@learnfi.lk</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

